import * as React from 'react'

const ApplyingIcon = props => (
  <svg
    width="88"
    height="92"
    viewBox="0 0 88 92"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M85.486 8.25103V83.747C85.486 86.9404 83.0109 89.5332 79.9625 89.5332H7.89455C4.84615 89.5332 2.37109 86.9404 2.37109 83.747V8.25103C2.37109 5.05763 4.84615 2.46484 7.89455 2.46484H79.9625C83.0109 2.46484 85.486 5.05763 85.486 8.25103Z"
      stroke="#ED4260"
      stroke-width="4"
    />
    <path
      d="M3.53125 68.4648H85.6259"
      stroke="#ED4260"
      stroke-width="4"
      stroke-miterlimit="10"
    />
    <path
      d="M3.53125 45.2969H85.6259"
      stroke="#ED4260"
      stroke-width="4"
      stroke-miterlimit="10"
    />
    <path
      d="M3.46875 22.125H85.5634"
      stroke="#ED4260"
      stroke-width="4"
      stroke-miterlimit="10"
    />
    <path
      d="M21.7854 22.1954C21.7854 25.5923 19.1568 28.3459 15.9142 28.3459C12.6716 28.3459 10.043 25.5923 10.043 22.1954C10.043 18.7986 12.6716 16.0449 15.9142 16.0449C19.1568 16.0449 21.7854 18.7986 21.7854 22.1954Z"
      fill="white"
    />
    <path
      d="M21.7854 22.1954C21.7854 25.5923 19.1568 28.3459 15.9142 28.3459C12.6716 28.3459 10.043 25.5923 10.043 22.1954C10.043 18.7986 12.6716 16.0449 15.9142 16.0449C19.1568 16.0449 21.7854 18.7986 21.7854 22.1954Z"
      stroke="#ED4260"
      stroke-width="4"
      stroke-miterlimit="10"
    />
    <path
      d="M79.5706 22.1954C79.5706 25.5923 76.942 28.3459 73.6994 28.3459C70.4567 28.3459 67.8281 25.5923 67.8281 22.1954C67.8281 18.7986 70.4567 16.0449 73.6994 16.0449C76.942 16.0449 79.5706 18.7986 79.5706 22.1954Z"
      fill="white"
    />
    <path
      d="M79.5706 22.1954C79.5706 25.5923 76.942 28.3459 73.6994 28.3459C70.4567 28.3459 67.8281 25.5923 67.8281 22.1954C67.8281 18.7986 70.4567 16.0449 73.6994 16.0449C76.942 16.0449 79.5706 18.7986 79.5706 22.1954Z"
      stroke="#ED4260"
      stroke-width="4"
      stroke-miterlimit="10"
    />
    <path
      d="M21.7854 45.0157C21.7854 48.4126 19.1568 51.1662 15.9142 51.1662C12.6716 51.1662 10.043 48.4126 10.043 45.0157C10.043 41.6189 12.6716 38.8652 15.9142 38.8652C19.1568 38.8652 21.7854 41.6189 21.7854 45.0157Z"
      fill="white"
    />
    <path
      d="M21.7854 45.0157C21.7854 48.4126 19.1568 51.1662 15.9142 51.1662C12.6716 51.1662 10.043 48.4126 10.043 45.0157C10.043 41.6189 12.6716 38.8652 15.9142 38.8652C19.1568 38.8652 21.7854 41.6189 21.7854 45.0157Z"
      stroke="#ED4260"
      stroke-width="4"
      stroke-miterlimit="10"
    />
    <path
      d="M79.5706 45.0157C79.5706 48.4126 76.942 51.1662 73.6994 51.1662C70.4567 51.1662 67.8281 48.4126 67.8281 45.0157C67.8281 41.6189 70.4567 38.8652 73.6994 38.8652C76.942 38.8652 79.5706 41.6189 79.5706 45.0157Z"
      fill="white"
    />
    <path
      d="M79.5706 45.0157C79.5706 48.4126 76.942 51.1662 73.6994 51.1662C70.4567 51.1662 67.8281 48.4126 67.8281 45.0157C67.8281 41.6189 70.4567 38.8652 73.6994 38.8652C76.942 38.8652 79.5706 41.6189 79.5706 45.0157Z"
      stroke="#ED4260"
      stroke-width="4"
      stroke-miterlimit="10"
    />
    <path
      d="M65.8128 68.1095C65.8128 71.5063 63.1842 74.26 59.9415 74.26C56.6989 74.26 54.0703 71.5063 54.0703 68.1095C54.0703 64.7126 56.6989 61.959 59.9415 61.959C63.1842 61.959 65.8128 64.7126 65.8128 68.1095Z"
      fill="white"
    />
    <path
      d="M65.8128 68.1095C65.8128 71.5063 63.1842 74.26 59.9415 74.26C56.6989 74.26 54.0703 71.5063 54.0703 68.1095C54.0703 64.7126 56.6989 61.959 59.9415 61.959C63.1842 61.959 65.8128 64.7126 65.8128 68.1095Z"
      stroke="#ED4260"
      stroke-width="4"
      stroke-miterlimit="10"
    />
    <path
      d="M80.219 68.1153C80.219 71.5122 77.5904 74.2659 74.3478 74.2659C71.1052 74.2659 68.4766 71.5122 68.4766 68.1153C68.4766 64.7185 71.1052 61.9648 74.3478 61.9648C77.5904 61.9648 80.219 64.7185 80.219 68.1153Z"
      fill="white"
    />
    <path
      d="M80.219 68.1153C80.219 71.5122 77.5904 74.2659 74.3478 74.2659C71.1052 74.2659 68.4766 71.5122 68.4766 68.1153C68.4766 64.7185 71.1052 61.9648 74.3478 61.9648C77.5904 61.9648 80.219 64.7185 80.219 68.1153Z"
      stroke="#ED4260"
      stroke-width="4"
      stroke-miterlimit="10"
    />
  </svg>
)

export default ApplyingIcon
